export const RoutesWeb = {
    shared: {
        home: "/",
        error: {
            forbidden: "/403",
        },
    },
    gerencia_tecnica_operaciones: {
        dashboard: "/gto/dashboard/:tabValue?",
        reports_close_daily: "/gto/reports/close_daily",
        reports_consolidate_bm: "/gto/reports/consolidate_bm",
        reports_consolidate_bcp: "/gto/reports/consolidate_bcp",
        reports_physical_check: "/gto/reports/physical_check",
        reports_consolidate_cards_bm: "/gto/reports/consolidate_cards_bm",
        reports_daily_summary: "/gto/reports/daily_summary",
        reports_overview: "/gto/reports/overview",
        upload: "/gto/upload",
        history: "/gto/history",
        upload_monitoreo: "/gto/upload/monitoreo",
        upload_monitoreoV2: "/gto/upload/monitoreoV2",
        upload_well_files: "/gto/upload/well_files",
        upload_backup_mobile: "/gto/upload/backup_mobile",
        task: "/gto/task/info/:id",
        details_location: "/gto/dashboard/location/detail/:id",
        analyst_summary: "/gto/analyst_summary",
        operations_summary_cards: "/gto/operations_summary/:startDate/:endDate/:type",
        pictures_agile_view: "/gto/pictures_agile_view/:startDate/:endDate/:type",
        list_of_optimizations: "/gto/list_of_optimizations/:startDate/:endDate",
    },
};
